<div class="block--content block" id="main-content">
    <article class="block--wrap block" [innerHTML]="'CEMV_FAQ_TEXT' | translate"></article>
</div>
